export const translations = {
  tr: {
    nav: {
      home: "Anasayfa",
      about: "Hakkımızda",
      services: "Hizmetler",
      projects: "Projeler",
      whyUs: "Neden Biz",
      contact: "İletişim",
      cta: "Projeye Başla"
    },
    hero: {
      eyebrow: "YENİ NESİL — TÜRKİYE",
      title1: "Yarına",
      title2: "Yön",
      title3: "Veriyoruz",
      hiddenTitle1: "Temeli",
      hiddenTitle2: "Biz",
      hiddenTitle3: "Atıyoruz",
      tagline: "Mayak — Rusça'da \"deniz feneri\" anlamına gelir. Yön, güven ve aydınlığın simgesidir. Üstlendiğimiz her projeye bu netliği taşıyoruz.",
      cta: "Projeye Başla",
      secondary: "Portföyü İncele",
      scroll: "Keşfetmek için kaydırın"
    },
    about: {
      eyebrow: "Hikayemiz",
      title: "Modern inşaat için yeni bir deniz feneri.",
      paragraph1: "Mayak Construction; mimari titizliği, mühendislik hassasiyetini ve kalıcı zanaatı tek bir çatı altında birleştiren genç ve iddialı bir stüdyodur. Her müşteriyi, inşaatın karmaşıklığında sağlam ve ilkeli bir el ile yönlendirme inancıyla kurulduk.",
      paragraph2: "Yükselen bir ekip olmamız nadir bir avantaj sağlar: her projeye kıdemli kadromuz birebir eğilir, her brief bir referans olarak ele alınır. Ölçek değil, özen önceliğimizdir.",
      values: {
        title: "Temel Değerler",
        items: [
          { title: "Yön", desc: "Tıpkı bir deniz feneri gibi inşaatın her aşamasında sarsılmaz bir rota sunarız." },
          { title: "Dürüstlük", desc: "Şeffaf bütçe, açık takvim ve her zaman sizin lehinize alınan kararlar." },
          { title: "Zanaat", desc: "Her detayda mimari titizlik ve malzeme disiplini hâkimdir." },
          { title: "Vizyon", desc: "Geleceği düşünerek inşa ederiz; nesiller boyu hizmet edecek yapılar kurarız." }
        ]
      }
    },
    services: {
      eyebrow: "Ne Yapıyoruz",
      title: "Uçtan uca inşaat uzmanlığı.",
      subtitle: "Dört disiplin, tek entegre ekip — aynı tavizsiz standartla teslim edilir.",
      learnMore: "Daha fazla",
      items: [
        {
          title: "İnşaat",
          short: "Sıfırdan ticari, konut ve hafif endüstriyel projeler.",
          long: "Temellerden teslime kadar yapısal, mekanik-elektrik ve bitiş kapsamlarını birleştirir; her şantiyeye takvim ve maliyet netliği getiririz."
        },
        {
          title: "Renovasyon",
          short: "Özenli restorasyon ve modern yenileme çalışmaları.",
          long: "Geçmişe saygıyla bugünü buluşturan detaylar; titiz araştırma ve düzenli bir saha disipliniyle hayata geçer."
        },
        {
          title: "Mimari",
          short: "Konseptten ruhsata mimari tasarım ve mühendislik.",
          long: "Lisanslı mimarlarımız ve mühendislerimiz, sahanın dokusu ve yapılabilirlik etrafında her konsepti şekillendirir; çizim duvara dönüşürken ödün verilmez."
        },
        {
          title: "Danışmanlık",
          short: "İnşaat yönetimi, maliyet ve teknik danışmanlık.",
          long: "Ekibinizin içinde ya da işveren tarafında konumlanır; kararları netleştirir, takvim risklerini azaltır ve karmaşık teslimleri sadeleştiririz."
        }
      ]
    },
    projects: {
      eyebrow: "Seçili İşler",
      title: "Güncel projeler.",
      subtitle: "Şekillendirmekte olduğumuz mekânlardan bir kesit.",
      filters: {
        all: "Tümü",
        construction: "İnşaat",
        renovation: "Renovasyon",
        architecture: "Mimari",
        consulting: "Danışmanlık"
      },
      viewProject: "Projeyi gör"
    },
    whyUs: {
      eyebrow: "Neden Mayak",
      title: "Müşterilerimizin bize döndüğü altı sebep.",
      items: [
        { title: "Sarsılmaz Yön", desc: "Bir deniz feneri gibi; net, ilkeli ve güvenilir bir rota sunarız." },
        { title: "Açık Hesap", desc: "Detaylı keşif raporları, şeffaf bütçeler ve her aşamada dürüst raporlama." },
        { title: "Kıdemli Eller", desc: "Her proje, kurucu mimar ve mühendislerimizin birebir ilgisini görür." },
        { title: "Önce Güvenlik", desc: "Ekiplerimize, iş ortaklarımıza ve geleceğin kullanıcılarına özen ve uyum." },
        { title: "Kalıcı Kalite", desc: "Teslimden on yıllar sonra performans gösterecek malzeme ve yöntem seçimi." },
        { title: "Yerel Kök, Geniş Vizyon", desc: "Türkiye'de kök salmış; her ölçekte iş kotaracak bir bakış açısı." }
      ]
    },
    contact: {
      eyebrow: "Sohbete Başlayın",
      title: "Bir sonraki yapıyı birlikte aydınlatalım.",
      subtitle: "Projenizi bize anlatın — konsept, program ya da brief. Bir iş günü içinde dönüş yapıyoruz.",
      form: {
        name: "Ad Soyad",
        email: "E-posta",
        phone: "Telefon (opsiyonel)",
        subject: "Proje türü",
        message: "Projenizden bahsedin",
        send: "Talebi Gönder",
        sending: "Gönderiliyor…",
        success: "Teşekkürler. En kısa sürede dönüş yapacağız.",
        error: "Bir şeyler ters gitti. Lütfen tekrar deneyin."
      },
      info: {
        office: "Genel Merkez",
        address: "Levent Mah. Büyükdere Cad. No: 201, Şişli, İstanbul",
        emailLabel: "E-posta",
        email: "studio@mayakconstruction.com",
        phoneLabel: "Telefon",
        phone: "+90 212 000 00 00",
        hoursLabel: "Çalışma Saatleri",
        hours: "Pzt–Cum  09:00–18:00"
      }
    },
    footer: {
      tagline: "Yarına Yön Veriyoruz",
      navigate: "Menü",
      contactCol: "İletişim",
      languages: "Dil",
      rights: "Tüm hakları saklıdır.",
      admin: "Yönetici"
    },
    theme: {
      light: "Aydınlık modu",
      dark: "Karanlık modu",
      toggle: "Tema değiştir"
    },
    admin: {
      passwordPrompt: "Yönetici şifresi",
      passwordPlaceholder: "Şifre",
      submit: "Giriş",
      cancel: "İptal",
      wrong: "Hatalı şifre",
      title: "Yönetim Paneli",
      subtitle: "Site içeriğini yönetin",
      logout: "Çıkış",
      tabs: {
        projects: "Projeler",
        messages: "Mesajlar",
        stats: "İstatistikler"
      },
      newProject: "Yeni proje",
      newStat: "Yeni istatistik",
      noMessages: "Henüz mesaj yok.",
      markRead: "Okundu işaretle",
      delete: "Sil",
      edit: "Düzenle",
      save: "Kaydet",
      cancelAction: "İptal",
      fields: {
        title: "Başlık",
        description: "Açıklama",
        category: "Kategori",
        image: "Görsel URL",
        year: "Yıl",
        location: "Konum",
        featured: "Öne çıkan",
        label: "Etiket",
        value: "Değer",
        suffix: "Sonek",
        order: "Sıra"
      }
    }
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      projects: "Projects",
      whyUs: "Why Us",
      contact: "Contact",
      cta: "Start a Project"
    },
    hero: {
      eyebrow: "RISING — TURKEY",
      title1: "We",
      title2: "Steer",
      title3: "Tomorrow",
      hiddenTitle1: "We",
      hiddenTitle2: "Build",
      hiddenTitle3: "Forever",
      tagline: "Mayak — Russian for \"lighthouse\" — symbolises guidance, trust, and clarity. We bring those qualities to every project we undertake.",
      cta: "Start a Project",
      secondary: "View Portfolio",
      scroll: "Scroll to discover"
    },
    about: {
      eyebrow: "Our Story",
      title: "A new lighthouse for modern construction.",
      paragraph1: "Mayak Construction is a young, ambitious studio that brings architectural rigour, engineering precision, and enduring craft under a single roof. We were founded on a simple conviction: every client deserves a steady, principled hand to guide them through the complexities of building.",
      paragraph2: "Being a rising practice gives us a rare advantage — every project receives senior attention, and every brief is treated as our calling card. We choose care over scale, and craft over claims.",
      values: {
        title: "Core Values",
        items: [
          { title: "Direction", desc: "Like a lighthouse, we offer steady direction through every phase of a build." },
          { title: "Integrity", desc: "Transparent budgets, honest timelines, decisions made in your interest — always." },
          { title: "Craft", desc: "Architectural rigour and material discipline shape every detail of what we deliver." },
          { title: "Vision", desc: "We build with the future in mind — projects that age with grace and serve generations." }
        ]
      }
    },
    services: {
      eyebrow: "What We Do",
      title: "End-to-end construction expertise.",
      subtitle: "Four disciplines, one integrated team — delivered to the same uncompromising standard.",
      learnMore: "Learn more",
      items: [
        {
          title: "Construction",
          short: "Ground-up commercial, residential and light industrial projects.",
          long: "From foundations to handover, we coordinate structural, MEP and finishing scopes — bringing schedule and cost clarity to every site we touch."
        },
        {
          title: "Renovation",
          short: "Considered restoration and contemporary refits.",
          long: "Restoration that respects the past, refits that serve modern life — guided by careful detailing and a disciplined site practice."
        },
        {
          title: "Architecture",
          short: "Concept-to-permit architectural design and engineering.",
          long: "Our licensed architects and engineers shape every concept around buildability and the texture of the site — drawing the line that becomes the wall, with no compromise in translation."
        },
        {
          title: "Consulting",
          short: "Construction management, cost & technical advisory.",
          long: "Embedded with your team or external client side, we clarify decisions, de-risk schedules, and unlock value engineering on complex builds."
        }
      ]
    },
    projects: {
      eyebrow: "Selected Work",
      title: "Recent projects.",
      subtitle: "A glimpse into the spaces we are shaping.",
      filters: {
        all: "All",
        construction: "Construction",
        renovation: "Renovation",
        architecture: "Architecture",
        consulting: "Consulting"
      },
      viewProject: "View project"
    },
    whyUs: {
      eyebrow: "Why Mayak",
      title: "Six reasons clients return.",
      items: [
        { title: "Steady Direction", desc: "Like a lighthouse, our methodology offers a clear, principled, dependable course." },
        { title: "Open Books", desc: "Detailed bills of quantities, transparent budgets, honest reporting at every milestone." },
        { title: "Senior Hands", desc: "Every project gets direct attention from our principal architects and engineers." },
        { title: "Safety First", desc: "Compliance and care for our crews, our partners, and your future occupants." },
        { title: "Built to Last", desc: "Materials and methods chosen to perform decades after handover." },
        { title: "Local Roots", desc: "Grounded in Turkey, building toward standards that travel anywhere our clients go." }
      ]
    },
    contact: {
      eyebrow: "Begin a Conversation",
      title: "Let's light what's next, together.",
      subtitle: "Tell us about your project — concept, programme, or commission. We respond within one business day.",
      form: {
        name: "Full name",
        email: "Email address",
        phone: "Phone (optional)",
        subject: "Project type",
        message: "Tell us about your project",
        send: "Send Inquiry",
        sending: "Sending…",
        success: "Thank you. We'll be in touch shortly.",
        error: "Something went wrong. Please try again."
      },
      info: {
        office: "Head Office",
        address: "Levent Mah. Büyükdere Cad. No: 201, Şişli, Istanbul, Turkey",
        emailLabel: "Email",
        email: "studio@mayakconstruction.com",
        phoneLabel: "Phone",
        phone: "+90 212 000 00 00",
        hoursLabel: "Hours",
        hours: "Mon–Fri  09:00–18:00"
      }
    },
    footer: {
      tagline: "Lighting tomorrow's skyline.",
      navigate: "Navigate",
      contactCol: "Contact",
      languages: "Language",
      rights: "All rights reserved.",
      admin: "Admin"
    },
    theme: {
      light: "Light mode",
      dark: "Dark mode",
      toggle: "Toggle theme"
    },
    admin: {
      passwordPrompt: "Enter admin password",
      passwordPlaceholder: "Password",
      submit: "Enter",
      cancel: "Cancel",
      wrong: "Incorrect password",
      title: "Admin Console",
      subtitle: "Manage your site content",
      logout: "Sign out",
      tabs: {
        projects: "Projects",
        messages: "Messages",
        stats: "Stats"
      },
      newProject: "New project",
      newStat: "New stat",
      noMessages: "No messages yet.",
      markRead: "Mark as read",
      delete: "Delete",
      edit: "Edit",
      save: "Save",
      cancelAction: "Cancel",
      fields: {
        title: "Title",
        description: "Description",
        category: "Category",
        image: "Image URL",
        year: "Year",
        location: "Location",
        featured: "Featured",
        label: "Label",
        value: "Value",
        suffix: "Suffix",
        order: "Order"
      }
    }
  },
  ru: {
    nav: {
      home: "Главная",
      about: "О нас",
      services: "Услуги",
      projects: "Проекты",
      whyUs: "Почему мы",
      contact: "Контакты",
      cta: "Начать проект"
    },
    hero: {
      eyebrow: "НОВОЕ ИМЯ — ТУРЦИЯ",
      title1: "Курс",
      title2: "на",
      title3: "Завтра",
      hiddenTitle1: "Строим",
      hiddenTitle2: "на",
      hiddenTitle3: "Века",
      tagline: "Маяк — символ света, направления и доверия. Мы привносим эту ясность в каждый проект, за который берёмся.",
      cta: "Начать проект",
      secondary: "Смотреть портфолио",
      scroll: "Прокрутите вниз"
    },
    about: {
      eyebrow: "Наша история",
      title: "Новый маяк современного строительства.",
      paragraph1: "Mayak Construction — молодая и амбициозная студия, объединяющая архитектурную дисциплину, инженерную точность и долговечное мастерство под одной крышей. Мы основаны на простом убеждении: каждому клиенту нужна твёрдая и принципиальная рука, ведущая через сложности стройки.",
      paragraph2: "Молодость даёт нам редкое преимущество: каждый проект получает внимание старших партнёров, каждая задача — словно наша визитная карточка. Мы выбираем качество и заботу, а не размах.",
      values: {
        title: "Наши ценности",
        items: [
          { title: "Направление", desc: "Как маяк, мы задаём устойчивый курс на каждом этапе строительства." },
          { title: "Честность", desc: "Прозрачные бюджеты, открытые сроки, решения в ваших интересах — всегда." },
          { title: "Мастерство", desc: "Архитектурная строгость и материальная дисциплина в каждой детали." },
          { title: "Видение", desc: "Строим с мыслью о будущем — здания, которые служат поколениям." }
        ]
      }
    },
    services: {
      eyebrow: "Что мы делаем",
      title: "Сквозная строительная экспертиза.",
      subtitle: "Четыре дисциплины, одна команда — с одинаково бескомпромиссным стандартом.",
      learnMore: "Подробнее",
      items: [
        {
          title: "Строительство",
          short: "Коммерческие, жилые и лёгкие промышленные объекты с нуля.",
          long: "От фундамента до сдачи мы координируем структурные, инженерные и отделочные работы — обеспечивая ясность сроков и бюджета на каждой площадке."
        },
        {
          title: "Реновация",
          short: "Внимательная реставрация и современная модернизация.",
          long: "Реставрация, уважающая прошлое, и обновление, отвечающее требованиям современной жизни — с дисциплинированной практикой на стройке."
        },
        {
          title: "Архитектура",
          short: "Архитектура и инженерия от концепции до разрешений.",
          long: "Лицензированные архитекторы и инженеры формируют концепцию вокруг исполнимости и характера участка — линия чертежа становится стеной без потерь."
        },
        {
          title: "Консалтинг",
          short: "Управление строительством, стоимостью и техаудиты.",
          long: "Внутри вашей команды или со стороны заказчика мы проясняем решения, снижаем риски сроков и помогаем находить ценность на сложных объектах."
        }
      ]
    },
    projects: {
      eyebrow: "Избранные работы",
      title: "Последние проекты.",
      subtitle: "Срез пространств, которые мы создаём.",
      filters: {
        all: "Все",
        construction: "Строительство",
        renovation: "Реновация",
        architecture: "Архитектура",
        consulting: "Консалтинг"
      },
      viewProject: "Смотреть проект"
    },
    whyUs: {
      eyebrow: "Почему Mayak",
      title: "Шесть причин, по которым клиенты возвращаются.",
      items: [
        { title: "Чёткий курс", desc: "Как маяк, наша методология задаёт ясный, принципиальный и надёжный курс." },
        { title: "Открытость", desc: "Подробные ведомости, прозрачные бюджеты, честные отчёты на каждом этапе." },
        { title: "Старшие специалисты", desc: "Каждый проект получает прямое внимание ведущих архитекторов и инженеров." },
        { title: "Безопасность", desc: "Соблюдение норм и забота о бригадах, партнёрах и будущих жителях." },
        { title: "На века", desc: "Материалы и методы, работающие десятилетиями после сдачи." },
        { title: "Локальные корни", desc: "Базируемся в Турции, строим по стандартам, понятным во всём мире." }
      ]
    },
    contact: {
      eyebrow: "Начнём диалог",
      title: "Осветим следующее вместе.",
      subtitle: "Расскажите о вашем проекте — концепция, программа или поручение. Отвечаем в течение одного рабочего дня.",
      form: {
        name: "Имя и фамилия",
        email: "Электронная почта",
        phone: "Телефон (необязательно)",
        subject: "Тип проекта",
        message: "Опишите ваш проект",
        send: "Отправить запрос",
        sending: "Отправка…",
        success: "Спасибо. Скоро свяжемся с вами.",
        error: "Что-то пошло не так. Попробуйте снова."
      },
      info: {
        office: "Главный офис",
        address: "Левент Мах. Бююкдере Джад. №201, Шишли, Стамбул",
        emailLabel: "Эл. почта",
        email: "studio@mayakconstruction.com",
        phoneLabel: "Телефон",
        phone: "+90 212 000 00 00",
        hoursLabel: "Часы работы",
        hours: "Пн–Пт  09:00–18:00"
      }
    },
    footer: {
      tagline: "Освещаем завтрашние горизонты.",
      navigate: "Навигация",
      contactCol: "Контакты",
      languages: "Язык",
      rights: "Все права защищены.",
      admin: "Админ"
    },
    theme: {
      light: "Светлая тема",
      dark: "Тёмная тема",
      toggle: "Переключить тему"
    },
    admin: {
      passwordPrompt: "Введите пароль администратора",
      passwordPlaceholder: "Пароль",
      submit: "Войти",
      cancel: "Отмена",
      wrong: "Неверный пароль",
      title: "Панель администратора",
      subtitle: "Управление контентом сайта",
      logout: "Выйти",
      tabs: {
        projects: "Проекты",
        messages: "Сообщения",
        stats: "Статистика"
      },
      newProject: "Новый проект",
      newStat: "Новая статистика",
      noMessages: "Сообщений пока нет.",
      markRead: "Отметить прочитанным",
      delete: "Удалить",
      edit: "Редактировать",
      save: "Сохранить",
      cancelAction: "Отмена",
      fields: {
        title: "Название",
        description: "Описание",
        category: "Категория",
        image: "URL изображения",
        year: "Год",
        location: "Локация",
        featured: "В избранном",
        label: "Метка",
        value: "Значение",
        suffix: "Суффикс",
        order: "Порядок"
      }
    }
  }
};

export const LANGUAGES = [
  { code: "tr", label: "TR" },
  { code: "en", label: "EN" },
  { code: "ru", label: "RU" }
];

